import { useQuery } from "react-query";
import AttendanceApiClient from "api/AttendanceApiClient";

export function useSchoolGroupsAttendance(schoolId) {
    return useQuery(["schoolGroupsAttendance", { schoolId }], () =>
        AttendanceApiClient.getSchoolGroupsAttendance(schoolId),
    );
}
